import { APP_API_TOKEN, TOKEN_KEY } from '@common/constants/shared';
import auth, {
  AuthenticationClient,
  AuthenticationClientOptions,
  Storage,
} from '@feathersjs/authentication-client';
import {
  AuthenticationRequest,
  AuthenticationResult,
} from '@feathersjs/authentication/lib';

import feathers, { Application } from '@feathersjs/feathers';
import rest, { Handler } from '@feathersjs/rest-client';
import AsyncStorage from '@react-native-async-storage/async-storage';
import appConfig from '../../../appConfig.json';
import { Platform } from 'react-native';
import axios from 'axios';
let appId: string;
if (Platform.OS === 'web') {
  appId = window.location.pathname
    .split('/')
    .filter((path) => path && path !== 'preview')[0];
} else {
  appId = appConfig.appId;
}

const restClient = rest(appConfig.baseUrl);
const app = feathers();

class MyAuthenticationClient extends AuthenticationClient {
  appId: string;
  constructor(app: Application, options: AuthenticationClientOptions) {
    super(app, options);

    if (Platform.OS === 'web') {
      this.appId = window.location.pathname
        .split('/')
        .filter((path) => path && path !== 'preview')[0];
    } else {
      this.appId = appConfig.appId;
    }
  }
  get storage(): Storage {
    return {
      getItem: (key: string) =>
        AsyncStorage.getItem && AsyncStorage.getItem(key),
      setItem: (key: string, value: any) => {
        AsyncStorage.setItem && AsyncStorage.setItem(key, value ?? '');
      },
      removeItem: (key: string) =>
        AsyncStorage.removeItem && AsyncStorage.removeItem(key),
    };
  }

  async getAccessToken() {
    const token = await this.storage.getItem(TOKEN_KEY);
    return token || APP_API_TOKEN;
  }

  async setAccessToken(accessToken: string) {
    return (
      this.storage.setItem &&
      this.storage.setItem(TOKEN_KEY, accessToken || APP_API_TOKEN)
    );
  }

  async authenticate(
    authentication?: AuthenticationRequest,
    params?: feathers.Params
  ): Promise<AuthenticationResult> {
    const newParams = {
      ...params,
      query: { appId },
    };

    return super.authenticate(authentication, newParams);
  }

  async logout(): Promise<AuthenticationResult | null> {
    return this.authenticate({ strategy: 'jwt', accessToken: APP_API_TOKEN });
  }

  async reAuthenticate(
    force?: boolean | undefined,
    strategy?: string | undefined
  ): Promise<AuthenticationResult> {
    const reAuthResult = await super.reAuthenticate(force, strategy);
    return reAuthResult;
  }
}

const client = restClient.axios(axios) as unknown as Handler;

app
  .configure(
    auth({
      Authentication: MyAuthenticationClient,
      storage: AsyncStorage,
      storageKey: TOKEN_KEY,
      path: 'v3/database/authmanagement',
    })
  )
  .configure(client);

app.hooks({
  error(context) {
    const { error } = context;
    console.log(error);
    return context;
  },
});

export default app;
